import React from 'react'
import HomeElement from './HomeElement';
import { useSelector } from 'react-redux';
import { State } from '../../redux/store';

const HomeLinksDoctor: React.FC = () => {
  const className = `px-10 py-6 bg-white hover:bg-main rounded-lg border flex flex-col justify-center items-center text-main`;
  const { userData } = useSelector((state: State) => state.login)

  return <div className='grid grid-cols-2 md:grid-cols-3 gap-2 mt-3'>
    <HomeElement Name='Docteurs' doctor={true} className={className} pageLink={`/doctor/${userData._id}/about/regform`} imgLink='assets/images/doctors.png' />      
    {/* <HomeElement Name='Cabinets' doctor={true} className={className} pageLink={`/cabinet`} imgLink='assets/images/cabinets.png' />       */}
  </div>

}

export default HomeLinksDoctor
